import React, { useEffect, useState } from "react";
import { Card, Button, Tag, Spin, Divider } from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const JobCardDetailsStudent = () => {
  const { id } = useParams();

  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  const fetchJob = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/jobs/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        setJob(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJob();
  }, []);

  const safeValue = (val) => {
  if (
    !val ||                      // null / undefined / empty
    val === "undefined" ||      // string "undefined"
    val === "null" ||           // string "null"
    val.trim() === ""           // empty string
  ) {
    return "Not Given";
  }
  return val;
};

  if (loading)
    return (
      <div className="flex justify-center mt-20">
        <Spin size="large" />
      </div>
    );

  if (!job)
    return (
      <div className="mt-20 text-center text-gray-500">
        No job found
      </div>
    );

    const website = job.Website?.trim();

const isValidWebsite =
  website &&
  website !== "null" &&
  website !== "undefined";

  return (
    <div className="max-w-6xl px-6 py-10 mx-auto">

      {/* HEADER */}
      <Card className="mb-8 border-0 shadow-lg rounded-3xl">

        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">

          {/* LEFT */}
          <div className="flex gap-5">

            <img
              src={job.CompanyLogo}
              alt="logo"
              className="object-cover w-20 h-20 border rounded-xl"
            />

            <div>
              <h1 className="text-3xl font-extrabold text-slate-900">
                {job.JobTitle}
              </h1>

              <p className="mt-1 text-gray-500">
                {job.CompanyName}
              </p>

              {/* TAGS */}
              <div className="flex flex-wrap gap-2 mt-3">
                <Tag color="blue">{job.WorkPreference}</Tag>
                <Tag color="purple">{job.Location}</Tag>
                <Tag color="green">Active</Tag>
              </div>

              <p className="mt-3 text-sm text-gray-500">
                Posted{" "}
                {dayjs(job.CreatedAt)
                  .add(5, "hour")
                  .add(30, "minute")
                  .fromNow()}
              </p>
            </div>

          </div>

          {/* APPLY BUTTON */}
          <div className="flex flex-col gap-3">
          <Button
           type="primary"
           size="large"
           onClick={() => {
         
            
           
             if (isValidWebsite) {
               window.open(website, "_blank");
             } else if (job.ContactEmail) {
               const subject = encodeURIComponent(
                 `Application for ${job.JobTitle}`
               );
         
               const body = encodeURIComponent(
                 `Hi,\n\nI am interested in applying for the ${job.JobTitle} position.\n\nPlease find my details below:\n\nName:\nExperience:\nSkills:\n\nThanks & Regards`
               );
         
               window.location.href = `mailto:${job.ContactEmail}?subject=${subject}&body=${body}`;
             } else {
               alert("No application method available");
             }
           }}
           className="px-8 font-semibold shadow-md rounded-xl"
         >
           {isValidWebsite ? "Apply Now →" : "Apply via Email →"}
         </Button>

            
          </div>

        </div>
      </Card>

      {/* ABOUT COMPANY */}
      <Card className="mb-6 shadow-sm rounded-2xl">
        <h2 className="mb-4 text-xl font-semibold text-slate-800">
          About the Company
        </h2>

        <div className="leading-7 whitespace-pre-line text-slate-600">
          {job.AboutTheCompany || "No details provided."}
        </div>
      </Card>

      {/* REQUIRED SKILLS */}
      <Card className="mb-6 shadow-sm rounded-2xl">
        <h2 className="mb-4 text-xl font-semibold text-slate-800">
          Required Skills
        </h2>

        <div className="flex flex-wrap gap-3">
          {job.RequiredSkills?.split(",").map((skill, i) => {
            const colors = [
              "bg-blue-50 text-blue-600 border-blue-200",
              "bg-green-50 text-green-600 border-green-200",
              "bg-purple-50 text-purple-600 border-purple-200",
              "bg-orange-50 text-orange-600 border-orange-200",
            ];

            return (
              <span
                key={i}
                className={`px-4 py-1.5 text-sm font-medium border rounded-lg ${
                  colors[i % colors.length]
                }`}
              >
                {skill.trim()}
              </span>
            );
          })}
        </div>
      </Card>

      {/* JOB SUMMARY */}
      <Card className="mb-6 shadow-sm rounded-2xl">
        <h2 className="mb-4 text-xl font-semibold text-slate-800">
          Job Summary
        </h2>

        <div className="leading-7 whitespace-pre-line text-slate-600">
          {job.JobSummary || "No summary provided."}
        </div>
      </Card>

      {/* DESIRED SKILLS */}
      <Card className="mb-6 shadow-sm rounded-2xl">
        <h2 className="mb-4 text-xl font-semibold text-slate-800">
          Desired Skills & Experience
        </h2>

        <div className="leading-7 whitespace-pre-line text-slate-600">
          {job.DesiredSkills || "No additional requirements."}
        </div>
      </Card>

      {/* CONTACT DETAILS */}
      <Card className="shadow-sm rounded-2xl">
        <h2 className="mb-4 text-xl font-semibold text-slate-800">
          Contact Details
        </h2>

        <Divider className="my-3" />

        <div className="space-y-2 text-slate-600">
         <p>
  <span className="font-medium text-slate-800">Email:</span>{" "}
  {safeValue(job.ContactEmail)}
</p>

<p>
  <span className="font-medium text-slate-800">Phone:</span>{" "}
  {safeValue(job.ContactPhone)}
</p>
        </div>
      </Card>

    </div>
  );
};

export default JobCardDetailsStudent;